import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Button,
  Input,
  FormFeedback,
  Col,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import classnames from "classnames";

import { getAccountDetail } from "connection/backend";
import Loader from "components/Common/Loader";

const DetailModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [balance_history, setBalanceHistory] = useState([]);

  const getData = async () => {
    setLoading(true);
    const response = await getAccountDetail(
      `?ticket_code=${props.ticket.code}`
    );
    setPayments(response.data.payments);
    setBalanceHistory(response.data.balance_history);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [props.modal]);

  const [activeTab, setActiveTab] = useState("1");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Modal
          isOpen={props.modal}
          toggle={props.toggleFunction}
          centered={true}
          backdrop="static"
          size="xl"
        >
          <ModalHeader
            toggle={props.toggleFunction}
            className="justify-content-center"
          >
            Detalle de movimientos ticket - <b>{props.ticket.code}</b>
          </ModalHeader>
          <ModalBody>
            <Nav tabs justified>
              <NavItem>
                <NavLink
                  to="#"
                  className={classnames({
                    active: activeTab === "1",
                  })}
                  onClick={() => {
                    toggle("1");
                  }}
                >
                  <span className="d-none d-sm-block">Pagos</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="#"
                  className={classnames({
                    active: activeTab === "2",
                  })}
                  onClick={() => {
                    toggle("2");
                  }}
                >
                  <span className="d-none d-sm-block">
                    Historial de saldo del cliente
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent className="p-4" activeTab={activeTab}>
              <TabPane id="payments" role="tabpanel" tabId="1">
                {payments.length > 0 ? (
                  <Table
                    className="table table-striped table-borderless align-middle table-centered table-nowrap mb-4"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th>Id</th>
                        <th>Método de pago</th>
                        <th>Banco</th>
                        <th>Valor</th>
                        <th>Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments.map((payment, idx) => (
                        <tr key={idx}>
                          <th scope="row">{payment.id}</th>
                          <td>
                            {payment.payment_method === "efectivo" &&
                              "Efectivo"}
                            {payment.payment_method === "consignacion" &&
                              "Consignación"}
                            {payment.payment_method === "cheque" && "Cheque"}
                          </td>
                          <td>
                            {payment.bank === "no_aplica" && "No aplica"}
                            {payment.bank === "banco_1" && "Banco de Bogotá"}
                            {payment.bank === "banco_2" && "Bancolombia"}
                          </td>
                          <td>$ {payment.value.toLocaleString("es-CO")}</td>
                          <td>{payment.created_date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <h3 className="card-title mb-4">
                    No se encontraron pagos para este ticket.
                  </h3>
                )}
              </TabPane>
              <TabPane id="balance_history" role="tabpanel" tabId="2">
                {balance_history.length > 0 ? (
                  <Table
                    className="table table-striped table-borderless align-middle table-centered table-nowrap mb-4"
                    size="sm"
                    style={{
                      textAlign: "center",
                      fontSize: "14px"
                    }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th>Id</th>
                        <th>Ticket</th>
                        <th>Pago</th>
                        <th>Valor</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {balance_history.map((balance, idx) => (
                        <tr key={idx}>
                          <th scope="row">{balance.id}</th>
                          <th scope="row">{balance.ticket}</th>
                          <th scope="row">{balance.payment}</th>
                          <td>$ {balance.value.toLocaleString("es-CO")}</td>
                          <td>
                            {balance.type === "deposito" ? (
                              <span
                                className={
                                  "badge rounded-pill bg-success bg-soft text-success"
                                }
                              >
                                <b>Depósito</b>
                              </span>
                            ) : (
                              <span
                                className={
                                  "badge rounded-pill bg-danger bg-soft text-danger"
                                }
                              >
                                <b>Débito</b>
                              </span>
                            )}
                          </td>
                          <td>{balance.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <h3 className="card-title mb-4">
                    No se encontraron registros.
                  </h3>
                )}
              </TabPane>
            </TabContent>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default DetailModal;
